import { Col, Row } from 'antd';

export function TableStat({ statData }) {
    if (!statData || statData.length === 0) return null;

    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            {statData.map((stat, index) => (
                <Col xs={24} sm={12} md={6} key={index}>
                    <div 
                        className="statCard animate-fade-in-up"
                        style={{ animationDelay: `${index * 50}ms` }}
                    >
                        <div className="statCardTitle">{stat.title}</div>
                        <div className="statCardValue" style={{ color: stat.color || 'var(--text-primary)' }}>
                            {stat.value}
                        </div>
                    </div>
                </Col>
            ))}
        </Row>
    );
}